const EntityGroupTemplates = [
    {
        text: "Split View",
        value: "Split View",
        pageTemplates: []
    },
    {
        text: "Gantt Chart",
        value: "Gantt Chart",
        pageTemplates: []
    },
    {
        text: "Table",
        value: "Table",
        pageTemplates: []
    },
    {
        text: "Cards",
        value: "Cards",
        pageTemplates: []
    },
    {
        text: "Kanban",
        value: "Kanban",
        pageTemplates: []
    },
    {
        text: "Calendar",
        value: "Calendar",
        pageTemplates: []
    },
    {
        text: "List",
        value: "List",
        pageTemplates: []
    },
    {
        text: "Search",
        value: "Search",
        pageTemplates: []
    },
];

const EntitySpecificTemplates = [
    {
        text: "Record Details",
        value: "Single Record",
        pageTemplates: [
            "Layout 1", "Layout 2"
        ]
    },
    {
        text: "New Record",
        value: "New Record",
        pageTemplates: []
    },
    {
        text: "Edit Record",
        value: "Edit Record",
        pageTemplates: []
    },
];

const LinkedRecordTemplates = [
    {
        text: "Linked Record Reference",
        value: "Linked Record Reference",
        pageTemplates: [
            "Cards", "Table", "Calendar", "Gantt Chart", "Form"
        ]
    },
    {
        text: "Linked Record All Records Table",
        value: "Linked Record All Records",
        pageTemplates: [
            "Table"
        ]
    },
    {
        text: "Link Records",
        value: "Link Record Table",
        pageTemplates: []
    },
];

const PageDataTypes = [
    {
        text: "Multiple Record",
        value: "Entity Group",
        subPageTypes: EntityGroupTemplates,
    },
    {
        text: "Single Record",
        value: "Entity Specific",
        subPageTypes: EntitySpecificTemplates
    },
    {
        text: "Linked Record",
        value: "Linked Record",
        subPageTypes: LinkedRecordTemplates
    },
];

export default PageDataTypes;